import { Component } from '@angular/core';
import { Recipe } from 'app/models/recipe.model';
import { RecipePage } from 'app/pages/switch-data-analisys/receipt-creation/receipt-creation.component';
import { Roles, UserProfile } from 'app/models/profile.models';

@Component({
	selector: 'edit-switch-recipe',
	templateUrl: '../../../switch-data-analisys/receipt-creation/receipt-creation.component.html',
	styleUrls: ['../../../switch-data-analisys/receipt-creation/receipt-creation.component.scss']
})
export class EditSwitchRecipePage extends RecipePage {
	_userProfile: UserProfile;
	private savedToMy = false;
	ngOnInit(): void {
		this.on(
			this.authService.isAuthenticated$.subscribe((isAutenticated) => {
				this.isAutenticated = isAutenticated;
				this._userProfileService.loadUserProfile().subscribe((profile) => {
					this._userProfile = profile;
					if (isAutenticated && !this.recipe) {
					this._activatedRoute.paramMap.subscribe((params) => {
						this.showGoBack = true;
						if (params.get("recipeId")) {
							this._recipeService.getSwitchRecipe(params.get("recipeId")).subscribe((recipe) => {
								this.recipe = recipe;
								this.pageLoaded = true;								
							})
						}
						else {
							this.pageLoaded = true;
						}
					})
				}
				})
				
			})
		)
	}

	saveEnabled = () => {
		return this._userProfile && this._userProfile.isInRole(Roles.RECIPE_EDITOR);
	}
	public storeRecipe = () => {
		if (this.isAutenticated && this._userProfile && this._userProfile.isInRole(Roles.RECIPE_EDITOR)) {
			this._recipeService.saveOrUpdateSwitchRecipe(this.recipe).subscribe((result) => {
				this.recipe.id = result.id;
				this._toastService.showSuccess(this._translateService.instant("recipePage.receipeSavedMessage"));
			})
			
		}
		else if (this.isAutenticated && this._userProfile && !this._userProfile.isInRole(Roles.RECIPE_EDITOR)) {
			let recipe: Recipe = new Recipe();
			Object.assign(recipe, this.recipe);
			if (!this.savedToMy) {
				delete recipe.id;
				this.savedToMy = true;
			}
			this._recipeService.saveOrUpdate(recipe).subscribe((result) => {
				this._toastService.showSuccess(this._translateService.instant("recipePage.receipeSavedMessage"));
				this.recipe.id = result.id;
			})			
		}
		
	}
}